import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Grid from '@material-ui/core/Grid';

import GiftsStore from 'stores/GiftsStore';
import ProfileStore from 'stores/ProfileStore';
import MobileProfileSocialMedia from 'components/MobileProfileSocialMedia/MobileProfileSocialMedia';
import ProfileAwards from 'components/ProfileAwards/ProfileAwards';
import ProfileSexQuestionnaire from 'components/ProfileSexQuestionnaire/ProfileSexQuestionnaire';
import UpcomingShows from 'components/UpcomingShows/UpcomingShows';
import WishListProfileV2 from 'components/WishListProfileV2/WishListProfileV2';
import UpcomingShowsStore from 'components/UpcomingShows/UpcomingShowsStore';
import useResize from 'hooks/useResize';

import Achievements from '../../Achievements';

import Attributes from './Attributes/Attributes';
import CustomHTML from './CustomHTML/CustomHTML';
import DetailedBio from './DetailedBio/DetailedBio';
import GiftShowcase from './GiftsShowcase/GiftShowcase';
import LatestContent from './LatestContent/LatestContent';
import styles from './Profile.css';


const AVERAGE_DESKTOP_WIDTH_THRESHOLD = 1024;

const Profile = (props) => {
  const { history, user, walletDetails, embedProfileV2 } = props;
  const { isThereShow, getUpcomingShows } = UpcomingShowsStore;
  const { wishList, isWishListVisible, profileName, profileInfo, isAwardAreaVisible } = ProfileStore;
  const hasSocialNetworks = profileInfo.socialNetworks && Object.keys(profileInfo.socialNetworks).length > 0;
  useEffect(() => {
    getUpcomingShows(profileName);
  }, [getUpcomingShows, profileName]);

  useEffect(() => {
    GiftsStore.getGiftList(profileName);
  }, [profileName]);

  const [width] = useResize();
  const normalDesktop = width >= AVERAGE_DESKTOP_WIDTH_THRESHOLD;

  return !embedProfileV2 ? (
    <div className={styles.profileWrapper}>
      <LatestContent user={user} walletDetails={walletDetails} />
      <Grid className={styles.reduceSpacing} container={true} spacing={3}>
        <Grid className={styles.leftColumn} item={true} sm={12}>
          {hasSocialNetworks && <MobileProfileSocialMedia margin={true} profileInfo={profileInfo} />}
          {isThereShow && <UpcomingShows history={history} />}
          <DetailedBio />
          {isAwardAreaVisible && normalDesktop && <ProfileAwards />}
          {isWishListVisible && normalDesktop && <WishListProfileV2 wishList={wishList} />}
        </Grid>
        <Grid item={true} sm={12}>
          {profileInfo.htmlBio && <CustomHTML />}
          <GiftShowcase />
          <Achievements profileName={profileName} />
          <ProfileSexQuestionnaire />
          <Attributes history={history} />
        </Grid>
      </Grid>
    </div>
  ) : null;
};

Profile.propTypes = {
  history: PropTypes.object.isRequired,
  embedProfileV2: PropTypes.bool,
  user: PropTypes.object,
  walletDetails: PropTypes.object,
};

export default observer(Profile);
